/**
 * HC Sold Out Overlay Handler - Simplified Version
 * Chỉ hiển thị overlay image khi sản phẩm sold out
 */

class HCSoldOutOverlay {
  constructor() {
    this.overlayElements = document.querySelectorAll('.hc-soldout-overlay');
    this.init();
  }

  init() {
    if (this.overlayElements.length === 0) return;
    
    this.setupOverlays();
    this.bindEvents();
  }

  setupOverlays() {
    this.overlayElements.forEach((overlay) => {
      const productItem = overlay.closest('.product-item');
      const isProductSoldOut = overlay.dataset.soldOut === 'true';
      
      if (isProductSoldOut) {
        this.showSoldOutState(overlay);
      } else {
        this.hideSoldOutState(overlay);
      }
      
      // Handle variant changes if on product page
      if (productItem) {
        this.observeVariantChanges(overlay, productItem);
      }
    });
  }

  showSoldOutState(overlay) {
    const overlayImage = overlay.querySelector('.hc-soldout-overlay__image');
    
    // Show overlay image if exists
    if (overlayImage) {
      overlayImage.classList.add('hc-soldout-overlay__image--show');
    }
    
    // Mark overlay as active
    overlay.classList.add('hc-soldout-overlay--active');
  }

  hideSoldOutState(overlay) {
    const overlayImage = overlay.querySelector('.hc-soldout-overlay__image');
    
    // Hide overlay image
    if (overlayImage) {
      overlayImage.classList.remove('hc-soldout-overlay__image--show');
    }
    
    // Remove active state
    overlay.classList.remove('hc-soldout-overlay--active');
  }

  observeVariantChanges(overlay, productItem) {
    // Listen for variant change events
    const variantSelectors = productItem.querySelectorAll('input[name^="options"], select[name^="options"]');
    
    variantSelectors.forEach((selector) => {
      selector.addEventListener('change', () => {
        this.handleVariantChange(overlay, productItem);
      });
    });
    
    // Observer for class changes on form wrapper
    const formWrapper = productItem.querySelector('.form__wrapper');
    if (formWrapper) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            this.handleVariantChange(overlay, productItem);
          }
        });
      });
      
      observer.observe(formWrapper, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  handleVariantChange(overlay, productItem) {
    // Check if current variant is sold out
    const formWrapper = productItem.querySelector('.form__wrapper');
    const isSoldOut = formWrapper && (
      formWrapper.classList.contains('variant--soldout') ||
      formWrapper.classList.contains('variant--unavailable')
    );
    
    // Update overlay data attribute
    overlay.dataset.soldOut = isSoldOut.toString();
    
    if (isSoldOut) {
      this.showSoldOutState(overlay);
    } else {
      this.hideSoldOutState(overlay);
    }
  }

  bindEvents() {
    // Handle dynamic content loading (infinite scroll, AJAX, etc.)
    document.addEventListener('DOMContentLoaded', () => {
      this.setupOverlays();
    });
    
    // Re-initialize when new products are loaded
    document.addEventListener('hc:productsLoaded', () => {
      this.overlayElements = document.querySelectorAll('.hc-soldout-overlay');
      this.setupOverlays();
    });
  }

  // Public method to refresh overlays
  refresh() {
    this.overlayElements = document.querySelectorAll('.hc-soldout-overlay');
    this.setupOverlays();
  }

  // Public method to update specific overlay
  updateOverlay(productId, isSoldOut) {
    const overlay = document.querySelector(`[data-product-id="${productId}"] .hc-soldout-overlay`);
    if (!overlay) return;
    
    overlay.dataset.soldOut = isSoldOut.toString();
    
    if (isSoldOut) {
      this.showSoldOutState(overlay);
    } else {
      this.hideSoldOutState(overlay);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.hcSoldOutOverlay = new HCSoldOutOverlay();
  });
} else {
  window.hcSoldOutOverlay = new HCSoldOutOverlay();
}

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = HCSoldOutOverlay;
}